import PropTypes from 'prop-types'

import useTranslations from '../../i18n/useTranslations'
import SearchFieldNotDummy from '../../ui/components/searchFieldNotDummy'
import { useStyles } from './styles'
import { Box } from '@mui/material'

const SearchInput = ({
  className,
  queryValue,
  search,
  clearSearch,
  placeholder,
  noHelperText,
}) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <Box className={className}>
      <SearchFieldNotDummy
        id="shippingCode"
        initialValue={queryValue}
        className={classes.shippingInput}
        helperText={
          !noHelperText ? t('home:shipment-locator-input-helper') 
          : null
        }
        placeholder={
          placeholder ?? t('home:shipment-locator-input-placeholder')
        }
        onSearch={search}
        onClear={clearSearch}
        showClearIcon
        showSearchIcon
      />
    </Box>
  )
}
SearchInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  noHelperText: PropTypes.bool,
  queryValue: PropTypes.string,
  search: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
}

export default SearchInput
